export default __webpack_public_path__ + "static/not_found-ca4efeb0a1eb8c81faaa1f2c76fc5fde.svg";